// Import package
import { v4 } from "uuid";
import {
  SET_AFFILIATE_POINTS_HISTORY_LOADING,
  SET_AFFILIATE_POINTS_HISTORY,
} from "../../constants/ActionTypes";

// Import file
import { baseRequest } from "../../util/Api";
import {
  setLoadingMessage,
  setSuccessMessage,
  setErrorMessage,
} from "./Common";

export const getAffiliatePointsHistory = (filter) => (dispatch) => {
  dispatch({
    type: SET_AFFILIATE_POINTS_HISTORY_LOADING,
    payload: true,
  });
  baseRequest("get", "/affiliate-points-history/", filter)
    .then((data) => {
      dispatch({
        type: SET_AFFILIATE_POINTS_HISTORY,
        payload: data,
      });
    })
    .catch((e) => {
      dispatch(setErrorMessage(e));
      dispatch({
        type: SET_AFFILIATE_POINTS_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const createAffiliatePointHistory = (data) => (dispatch) =>
  new Promise((resolve, reject) => {
    const key = v4();
    dispatch(setLoadingMessage("Menambah affiliate point ...", key));
    baseRequest("post", "/affiliate-points-history/", null, data)
      .then((newData) => {
        dispatch(
          setSuccessMessage("Menambahkan daftar penggunaan affiliate point", key)
        );
        resolve(newData);
      })
      .catch((e) => {
        dispatch(setErrorMessage(e, key));
        reject(e);
      });
  });
